import { TournamentEntity } from 'app/interfaces/entity';
import { useMemo } from 'react';
import { useCurrentUserTeamId } from './use-current-user-team-id';

export const useTeamPrize = (tournament?: TournamentEntity) => {
  const { currentUserTeamId } = useCurrentUserTeamId(tournament);

  const teamPrize = useMemo(() => {
    const prizes =
      tournament?.results
        ?.filter((result) => result.teamId === currentUserTeamId)
        .map((result) => result.playerPrize ?? 0) ?? [];

    return prizes.reduce((prize, total) => prize + total, 0);
  }, [currentUserTeamId, tournament?.results]);

  return { teamPrize };
};
